export const USA_CENTER_LON_LAT = [-97, 38];
export const INITIAL_MAP_MAX_ZOOM = 18;
export const INITIAL_MAP_MIN_ZOOM = 4.3;
